export type { IdealSIPPlanAdviceCardDisplay } from '../../types/adviceCards.types'
import type {
  ElitePrimeIdealPlanData,
  ElitePrimeStrategyData
} from '../../../../types/elitePrimeSummary.types'
import type { AdviceCardStat, IdealSIPPlanAdviceCardDisplay } from '../../types/adviceCards.types'
import {
  buildStrategyFindCopyDisplay,
  buildStrategyUnderReviewStats,
  isStrategyFindCopyStatus,
  isStrategyQuestionnaireSubmittedStatus
} from './adviceCardStrategyStatusDisplay'

function buildActiveIdealSipPlanStats(planData: ElitePrimeIdealPlanData): AdviceCardStat[] {
  const stats: AdviceCardStat[] = []
  const idealSips = planData.idealFunds ?? 0
  const idealCategories = planData.idealCategories ?? 0

  if (idealSips > 0) {
    stats.push({ value: `${idealSips} ideal`, label: 'SIPs' })
  }

  if (idealCategories > 0) {
    stats.push({ value: `${idealCategories} ideal`, label: 'categories' })
  }

  return stats
}

export function buildIdealSIPPlanAdviceCardDisplay({
  planData,
  strategyData
}: {
  planData?: ElitePrimeIdealPlanData
  strategyData?: ElitePrimeStrategyData
}): IdealSIPPlanAdviceCardDisplay {
  const status = strategyData?.status

  if (isStrategyFindCopyStatus(status)) {
    return buildStrategyFindCopyDisplay('Find your allocation strategy for Ideal SIP plan')
  }

  if (isStrategyQuestionnaireSubmittedStatus(status)) {
    return {
      stats: buildStrategyUnderReviewStats({
        planLabel: 'Ideal SIP Plan',
        planAvailableAt: planData?.planAvailableAt,
        planAvailableInDays: strategyData?.planAvailableInDays
      }),
      insightTone: 'orange'
    }
  }

  if (!planData) {
    return { stats: [], insightTone: 'orange' }
  }

  const planAvailableAt = planData.planAvailableAt
  if ((planAvailableAt ?? 0) > Date.now()) {
    return {
      stats: buildStrategyUnderReviewStats({
        planLabel: 'Ideal SIP Plan',
        planAvailableAt
      }),
      insightTone: 'orange'
    }
  }

  const activeStats = buildActiveIdealSipPlanStats(planData)
  if (activeStats.length > 0) {
    return { stats: activeStats, insightTone: 'orange' }
  }

  return { stats: [], insightTone: 'orange' }
}
